<template>
  <div class="px-4 text-sm last:mb-4" :class="{ 'my-4': !noYGap }">
    <slot />
  </div>
</template>

<script lang="ts" setup>
interface Props {
  noYGap?: boolean;
}

withDefaults(defineProps<Props>(), {
  noYGap: false,
});
</script>

<style scoped lang="scss"></style>
